"use client";

import { FC } from "react";
import { Container } from "@mui/material";

import ExpandTextWTB from "@/components/Paragraph/ExpandTextWTB";
import { ContentManagement } from "@/libs/types/content-management.type";

type VehicleContentProps = {
  content: ContentManagement[];
};

const VehicleContent: FC<VehicleContentProps> = ({ content }) => {
  return (
    <Container
      maxWidth="2xl"
      sx={{
        width: "100%",
      }}
    >
      {content.length > 0 && <ExpandTextWTB data={content} breakPoint={2} />}
    </Container>
  );
};

export default VehicleContent;
